import React from 'react';

// Özel envanter ikonları — hem ana sayfa Envanter Özeti'nde
// (InventorySummaryCards) hem de Protokol Parkları sekmesinde aynı görsel
// kullanılsın diye ortak modülde tutulur.

// Elektrik Direği — ters L şeklinde, ampul vurgulu
export const LightPoleIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="4" y1="4" x2="12" y2="4" strokeWidth="3.5" stroke="#6b7280" opacity="0.8" />
    <line x1="12" y1="4" x2="12" y2="20" strokeWidth="3.5" stroke="#374151" opacity="1" />
    <circle cx="4" cy="4" r="4" fill="#fbbf24" stroke="#f59e0b" strokeWidth="1.5" />
    <circle cx="4" cy="4" r="2.5" fill="#fcd34d" />
    <circle cx="3.3" cy="3.3" r="1" fill="white" opacity="0.8" />
    <line x1="1" y1="4" x2="0" y2="2" stroke="#fbbf24" strokeWidth="2" opacity="0.7" />
    <line x1="4" y1="1" x2="4" y2="0" stroke="#fbbf24" strokeWidth="2" opacity="0.7" />
    <line x1="7" y1="4" x2="8" y2="2" stroke="#fbbf24" strokeWidth="2" opacity="0.7" />
    <line x1="4" y1="7" x2="4" y2="8" stroke="#fbbf24" strokeWidth="2" opacity="0.7" />
    <circle cx="12" cy="4" r="2" fill="#4b5563" opacity="0.9" />
    <rect x="10" y="20" width="4" height="2.5" fill="#374151" opacity="0.8" rx="1" />
    <rect x="9" y="22" width="6" height="1" fill="#1f2937" opacity="0.6" rx="0.5" />
  </svg>
);

// Park Bankı
export const BenchIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect x="3" y="11" width="18" height="2" rx="1" />
    <rect x="3" y="7" width="18" height="2" rx="1" />
    <line x1="5" y1="13" x2="5" y2="20" />
    <line x1="7" y1="9" x2="7" y2="20" />
    <line x1="19" y1="13" x2="19" y2="20" />
    <line x1="17" y1="9" x2="17" y2="20" />
    <line x1="4" y1="20" x2="8" y2="20" />
    <line x1="16" y1="20" x2="20" y2="20" />
  </svg>
);
